var _polygon, _line, _polygon2, _g, _g2, _path, _path2, _g3, _line2, _line3, _polygon3, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 742.804 436.556",
    enableBackground: "new 0 0 742.804 436.556",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C7BDD7",
    points: "390.307,272.07 361.394,307.409 324.238,272.116 297.926,298.198 277.73,272.116 333.551,178.904  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#694A94",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 538.977,
    y1: 130.381,
    x2: 538.977,
    y2: 61.685
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#94E026",
    points: "540.193,61.678 540.193,87.343 566.475,73.381 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000003088927104029294910000005269945922086373289_",
    x: 473.989,
    y: 122.894,
    width: 139.899,
    height: 146.456
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011000702686224810100000004961374824725289877_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003088927104029294910000005269945922086373289_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_00000011000702686224810100000004961374824725289877_)",
    fill: "#C7BDD7",
    points: "604.249,239.14  575.143,268.279 530.135,223.736 503.822,249.818 483.626,223.736 538.97,130.39  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000111178459762084910610000000174224405005058970_",
    points: "483.807,223.736 504.003,249.818  530.315,223.736 575.323,268.279 604.069,240.241 538.79,131.491  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140000118882264994300000014881127782700189069_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111178459762084910610000000174224405005058970_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000140000118882264994300000014881127782700189069_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: " M655.51,191.234L501.845,344.898 M652.999,187.718L499.333,341.383 M649.354,185.079L495.69,338.743 M646.842,181.563 L493.179,335.227 M643.366,179.089L489.701,332.753 M640.854,175.573L487.19,329.239 M637.21,172.935L483.546,326.598  M634.7,169.418L481.035,323.082 M631.622,166.849L477.956,320.513 M629.109,163.332L475.444,316.996 M625.466,160.693 L471.801,314.357 M622.954,157.177L469.289,310.842 M619.478,154.703L465.812,308.367 M616.966,151.188L463.3,304.851  M613.322,148.548L459.657,302.212 M610.811,145.033L457.145,298.696 M607.518,142.77L453.854,296.433 M605.009,139.253 L451.343,292.918 M601.365,136.614L447.699,290.278 M598.853,133.098L445.188,286.761 M595.374,130.624L441.711,284.287  M592.865,127.109L439.2,280.774 M589.221,124.469L435.556,278.134 M586.71,120.952L433.044,274.617 M583.631,118.383 L429.965,272.047 M581.121,114.867L427.455,268.531 M577.478,112.228L423.81,265.893 M574.965,108.713L421.298,262.376  M571.487,106.238L417.822,259.902 M568.977,102.723L415.31,256.387 M565.334,100.082L411.667,253.747 M562.822,96.567 L409.157,250.23"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#694A94",
    strokeWidth: 1.697,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M457.638,265.198l-45.324-56.256l-34.992,41.263 M665.551,341.267L538.967,130.396L412.29,341.661"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#694A94",
    strokeWidth: 1.697,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M272.375,341.677L167.429,207.371L66.766,341.662 M421.68,325.208l-87.938-146.467l-82.784,135.717"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036241041455970051300000003327363301806362047_",
    x: 268.092,
    y: 171.408,
    width: 131.853,
    height: 137.072
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111161833006628081150000001069375657305615551_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036241041455970051300000003327363301806362047_",
    overflow: "visible"
  }))))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#694A94",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 333.551,
    y1: 178.616,
    x2: 333.551,
    y2: 109.92
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#694A94",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 167.429,
    y1: 207.53,
    x2: 167.429,
    y2: 138.834
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#94E026",
    points: "334.766,109.912 334.766,135.578 361.048,121.616 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#94E026",
    points: "168.645,138.826 168.645,164.492 194.926,150.53 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.3f9dae79cf37161b2675223c3d7b6ddf.svg";
export { ForwardRef as ReactComponent };